/**
 * @fileoverview Agent definition for world-organization-details-ideation-v3.
 *
 * This agent generates creative directions for developing an organization's details.
 * The user selects one direction before full details are generated.
 *
 * @category world-building.organizations.details
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'world-organization-details-ideation-v3',
  kind: 'primitive',
  name: 'World Organization Details Ideation',
  description: 'Generates creative directions for developing an organization before full detail generation.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.organizations.details',
    usedBy: ['use-world-organization-details-ideation-v3.ts'],
    usedInComposites: [],
    relatedAgents: ['world-organization-details-generator-v3'],
  },
};
